import { render, staticRenderFns } from "./InputKasMutasiHo.vue?vue&type=template&id=216fba6a&"
import script from "./InputKasMutasiHo.vue?vue&type=script&lang=js&"
export * from "./InputKasMutasiHo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports